import { LegacyUpgradeBody } from "common/firebase-function-types";
import { getAppFacilities } from "webapp/lib/app-renderer";

export async function legacyUpgrade(body: LegacyUpgradeBody): Promise<boolean> {
    const res = await getAppFacilities().callAuthCloudFunction("legacyUpgrade", body);
    if (res === undefined) return false;
    return res.ok;
}
